<div class="flex-container">
  <div nz-col nzSpan="6" class="page-content--left">
    <form class="filter-form" nz-form (ngSubmit)="search()">
      <div class="filter-form__header sticky">
        <button class="button float-left" nz-button nzType="secondary" type="button" (click)="emptyFilter()">
          {{ 'integration.log-01.btn.reset' | translate }}
        </button>
        <button class="button float-right" nz-button nzType="primary" [disabled]="loading" type="submit">
          {{ 'integration.log-01.btn.search' | translate }}
        </button>
      </div>
      <div class="filter-form__body">
        <hw-panel-form-item label="{{ 'integration.log-01.label.message' | translate }}">
          <input nz-input name="message" [(ngModel)]="params.messageId" />
        </hw-panel-form-item>
        <hw-panel-form-item class="date-picker-group" label="{{ 'integration.log-01.label.date-from' | translate }}">
          <hw-date-time-picker name="date-lower" [(ngModel)]="params.dateFrom"></hw-date-time-picker>
        </hw-panel-form-item>
        <hw-panel-form-item class="date-picker-group" label="{{ 'integration.log-01.label.date-to' | translate }}">
          <hw-date-time-picker name="date-upper" [(ngModel)]="params.dateTo"></hw-date-time-picker>
        </hw-panel-form-item>
        <hw-panel-form-item label="{{ 'integration.log-01.label.service' | translate }}">
          <nz-select
            name="service"
            nzShowSearch
            [(ngModel)]="params.service"
            nzAllowClear="true"
            [nzDropdownMatchSelectWidth]="false">
            <nz-option
              *ngFor="let service of services"
              nzLabel="{{ service.code }} - {{ service.description }}"
              [nzValue]="service.code"></nz-option>
          </nz-select>
        </hw-panel-form-item>
        <hw-panel-form-item label="{{ 'integration.log-01.label.participant' | translate }}">
          <nz-select name="participant" nzShowSearch [(ngModel)]="params.participant" nzAllowClear="true">
            <nz-option
              *ngFor="let participant of participants"
              nzLabel="{{ participant.code }}"
              [nzValue]="participant.code"></nz-option>
          </nz-select>
        </hw-panel-form-item>
        <hw-panel-form-item label="{{ 'integration.log-01.label.status' | translate }}">
          <nz-select name="status" [(ngModel)]="params.status" [nzAllowClear]="true">
            <nz-option nzLabel="OK" nzValue="OK"></nz-option>
            <nz-option nzLabel="FAILED" nzValue="FAILED"></nz-option>
            <nz-option nzLabel="RESENT" nzValue="RESENT"></nz-option>
            <nz-option nzLabel="STOPPED" nzValue="STOPPED"></nz-option>
          </nz-select>
        </hw-panel-form-item>
        <hw-panel-form-item label="{{ 'integration.log-01.label.direction' | translate }}">
          <nz-select name="direction" [(ngModel)]="params.direction" [nzAllowClear]="true">
            <nz-option nzLabel="{{ 'integration.log-02.direction.in' | translate }}" nzValue="in"></nz-option>
            <nz-option nzLabel="{{ 'integration.log-02.direction.out' | translate }}" nzValue="out"></nz-option>
          </nz-select>
        </hw-panel-form-item>
        <hw-panel-form-item label="{{ 'integration.log-01.label.content' | translate }}">
          <input nz-input name="content" [(ngModel)]="params.content" />
        </hw-panel-form-item>
        <hw-panel-form-item label="{{ 'integration.log-01.label.reference' | translate }}">
          <hw-term-codesystem-concept-select
            display="name"
            name="log-reference-type"
            [codesystem]="'log-reference-type'"
            [(ngModel)]="resource">
          </hw-term-codesystem-concept-select>
          <nz-input-group nzCompact>
            <input name="resource-id" type="text" nz-input [(ngModel)]="resourceId" />
          </nz-input-group>
        </hw-panel-form-item>
      </div>
    </form>
  </div>
  <nz-content class="page-content--header-inside">
    <hw-page-header header="integration.log-01.header" class="page-header">
      <button class="button float-right" nz-button nzType="secondary" type="button" (click)="printLogReport()">
        {{ 'integration.log-01.btn.report' | translate }}
      </button>
    </hw-page-header>
    <div class="page-content__flex-cols-container">
      <hw-backend-table
        *ngIf="logs"
        nz-col
        nzSpan="24"
        [query]="params"
        (dataChange)="getLogs()"
        [result]="logs"
        [loading]="loading">
        <hw-backend-column title="integration.log-01.title.date" sort="date">
          <ng-template #cellTemplate let-log>
            <a [routerLink]="['/integration/logs/view', log.id]">{{ log.date | localDateTime }}</a>
          </ng-template>
        </hw-backend-column>
        <hw-backend-column title="integration.log-01.title.message">
          <ng-template #cellTemplate let-log>
            {{ log.messageId }}
          </ng-template>
        </hw-backend-column>
        <hw-backend-column title="integration.log-01.title.service">
          <ng-template #cellTemplate let-log>
            {{ log.service.description }}
          </ng-template>
        </hw-backend-column>
        <hw-backend-column title="integration.log-01.title.direction">
          <ng-template #cellTemplate let-log>
            {{ log.direction === 'in' ? log.participant.code + ' → HEDA' : 'HEDA → ' + log.participant.code }}
          </ng-template>
        </hw-backend-column>
        <hw-backend-column title="integration.log-01.title.status">
          <ng-template #cellTemplate let-log>
            <nz-tag [nzColor]="'green'" *ngIf="log.status === 'OK'">{{ log.status }}</nz-tag>
            <nz-tag [nzColor]="'red'" *ngIf="log.status === 'FAILED'">{{ log.status }}</nz-tag>
            <nz-tag [nzColor]="'blue'" *ngIf="log.status === 'RESENT'">{{ log.status }}</nz-tag>
            <nz-tag [nzColor]="'gray'" *ngIf="log.status === 'STOPPED'">{{ log.status }}</nz-tag>
          </ng-template>
        </hw-backend-column>
      </hw-backend-table>
    </div>
  </nz-content>
</div>
